import React, { useContext, useEffect, useState } from "react";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { Form, Button, Input, Select, Checkbox } from "antd";
import { store } from "../../../../../../../redux";
import { setDraft } from "../../../../../../../redux/actions/skill";
import { notify } from "../../../../../../../redux/actions/snackActions";
import captureXpathIcon from "../../../../../../../images/capture-xpath.png";
import ReactTooltip from "react-tooltip";
import { useDispatch } from "react-redux";

const HoverConfig = () => {
  const dispatch = useDispatch();
  let { selectedNode: node, flowVariables, nodes } = useContext(BuilderContext);
  const { closeDrawer: cancel } = useDrawer();
  const [nodeData, setNodeData] = useState(null);
  const [frameData, setFrameData] = useState();
  const [form] = Form.useForm();

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };

  const handleSubmit = async () => {
    try {
      let obj = {};
      const values = await form.validateFields();
      let {
        skillReducer: { trainDraft },
      } = store.getState();
      nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
      obj.selector = values.selector;
      obj.selectorType = "elSelector";

      let newActions = findAndUpdate(nodes, nodeData.id, obj);
      store.dispatch(
        setDraft({
          ...trainDraft,
          RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
        })
      );

      cancel();
    } catch (error) {
      console.log("form error");
    }
  };

  const xPathHandler = (evt) => {
    const xPath = evt.detail.xPath;
    const frame = evt.detail.frame;
    setFrameData(frame);
    form.setFieldsValue({
      selector: xPath,
      frame: frame,
    });
  };

  const captureXpath = (nodeId) => {
    window?.chrome?.runtime.sendMessage(process.env.REACT_APP_CHROME_TAB_ID, {
      type: "captureXPath",
      nodeId: nodeId,
    });
  };

  useEffect(() => {
    document.addEventListener("capturedXPath", xPathHandler);
    return () => {
      console.log("[Unmounting]");
      document.removeEventListener("capturedXPath", xPathHandler, true);
    };
  }, []);

  useEffect(() => {
    setNodeData(node);
  }, [node]);

  return (
    <div>
      {nodeData ? (
        <div>
          <Form form={form} initialValues={nodeData}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Form.Item
                name="selector"
                label="Element Xpath"
                rules={[{ required: true }]}
                help="Eg: /html/body/div[3]/div/div[3]/div"
              >
                <Input defaultValue={nodeData.selector} />
              </Form.Item>
              <Button
                className="capture-btn"
                onClick={() => {
                  captureXpath(nodeData.id);
                }}
                style={{
                  height: "30px",
                  marginRight: "0px",
                  marginTop: "-3px",
                }}
                icon={
                  <img src={captureXpathIcon} data-tip="Capture Xpath"></img>
                }
              ></Button>
              <ReactTooltip place="top" type="dark" effect="solid" />
            </div>
          </Form>

          <div>
            <Button onClick={cancel}> Cancel </Button>
            <Button type="primary" onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </div>
      ) : null}
      <ul className="note-list">
        <li>Hover over an element.</li>
      </ul>
    </div>
  );
};

export default HoverConfig;
